import React from "react";
import "./index.scss"; // Import the styles for the component
import img from "../../../assets/images/map.png"; // Import the image
import { InterventionIcon } from "../../../assets/icons/InterventionIcon";
export const Intervention = () => {
  return (
    <div className="intervention mt-4">
      <div className="intervention-container d-flex align-items-center">
        <div className="row ms-0 justify-content-center  gx-0 w-100 align-items-center">
          <div className="col-12 col-md-6 mx-auto ">
            <p className="intervention-title">Notre zone d’intervention</p>
            <p className="intervention-text">
              Nous intervenons dans l’ensemble de la région Île-de-France, avec
              une forte présence dans les départements suivants
            </p>
            <div className="d-flex flex-wrap align-items-center intervention-liste">
              <InterventionIcon />
              Hauts-de-Seine (92)
            </div>
            <div className="d-flex flex-wrap align-items-center intervention-liste">
              <InterventionIcon />
              Val-d’Oise (95)
            </div>
            <div className="d-flex flex-wrap align-items-center  intervention-liste">
              <InterventionIcon />
              Paris (75)
            </div>
            <div className="d-flex flex-wrap align-items-center intervention-liste">
              <InterventionIcon />
              Yvelines et Val-de-Marne sur demande
            </div>
          </div>
          <div className="col-12 col-md-6 mx-auto d-flex justify-content-center">
            <img
              src={img}
              alt="Bento Habitat"
              className="img-fluid d-none  d-md-block"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
